// extracted by mini-css-extract-plugin
export default {"modal_wrapper":"BackgroundModal_modal_wrapper__jz7ub","modal_title":"BackgroundModal_modal_title__2d0WZ","modal_text":"BackgroundModal_modal_text__4NXaj"};